@use "@ebay/skin/dist/variables/variables";

.item {
  border: 1px solid var(--color-border-strong);
  border-radius: 4px;
  display: inline-block;
  height: 2em;
  margin-bottom: 4px;
  margin-right: 8px;
  vertical-align: middle;
  width: 50px;
}

.list {
  column-count: 2;
  list-style: none;
  margin: 0;
  padding: 0;
}

@media screen and (min-width: variables.$screen-size-XL) {
  .list {
    column-count: 3;
  }
}

@media screen and (min-width: variables.$screen-size-XL3) {
  .list {
    column-count: 5;
  }
}
